import { ImageTypes } from "~enums/imageTypes.ts";
import type { StaffListItem } from "~pages/Staff/StaffListPage/types/staffListItem.ts";
import type { RoleResponse } from "~types/role.ts";
import { findImageByTypes } from "~utilities/findImageByTypes.ts";

export const transformStaffResponse = (response: RoleResponse): StaffListItem[] => {
  const persons = response.includes?.resources?.persons;

  return response.data.map((role) => {
    const person = persons?.[role.person.id];

    return {
      avatarUrl: findImageByTypes(person?.images, [ImageTypes.PersonHead])?.url ?? "",
      dateOfBirth: person?.dob ?? null,
      entityId: role.entityId,
      externalId: role.externalId,
      gender: person?.gender ?? null,
      nameFullLocal: person?.nameFullLocal ?? "",
      nationality: person?.nationality ?? null,
      personExternalId: person?.externalId ?? null,
      personId: role.personId,
      role: role.role,
      roleId: role.roleId,
      status: role.status,
    };
  });
};
